export default {
	Language: 'Japonca',
	system: {
		homePage: {
			title1: 'Başlık 1',
			title2: 'Başlık 2',
			description1: 'Son 7 gün',
			description2: 'Son 6 ay',
		}
	},
	login:{
		register:'Üye Kaydı',
		usernamePls:'Kullanıcı adınızı girin',
		passwordPls:'Şifrenizi girin',
		toRegister:'Hesabınız yok mu? Hemen kaydolun',
		doLogin:'Giriş Yap',	  
	},
	register:{
		repasswordPls:'Para çekme şifrenizi girin',  
		codePls:'Davet kodunu girin',  
		register:'Kayıt Ol',
		xieyi:'Kullanım koşullarını kabul ediyorum',
		xieyiPls:'Lütfen aşağıdaki hesap açma protokolünü seçin!',
	},
	mine:{
		xyfs:'Kredi Skoru',
		ljjf:'Toplam Puan',
		recharge:'Puan Yükle',
		withdraw:'Puan Çek',
		money:'Sahip Olunan Puan',
		infomation:'Temel Bilgiler',
		moneylog:'Puan Kullanım Geçmişi',
		withdrawrecord:'Para Çekme Geçmişi',
		gamerecord:'Hediye Kayıtları',
		notice:'Duyurular',
		mymove:'İzleme Geçmişi',
		loginpwd:'Giriş Şifresi',
		paypwd:'Şifre Kullanımı',
		loginout:'Çıkış Yap',
		paypwdhasseted:'Nakit çekme şifresi ayarlanmış. Değiştirmek için müşteri hizmetleriyle iletişime geçin',
		setbank:'Lütfen yatırma kartınızı ayarlayın!',
		lorr:'Giriş Yap / Kayıt Ol',
	},
	infomation:{
		username:'Üye ID',
		name:'Ad Soyad',
		bankcard:'Para Çekme Hesabı',
		phone:'Cep Telefonu Numarası',
		recharge:'Yükleme',
		amount:'Sahip Olunan Puan',
		toserve:'Müşteri Hizmetleri ile iletişime geçin',
		kfms:'Çevrimdışı yükleme yapmak istiyorsanız müşteri hizmetleriyle iletişime geçin. Bazı ödeme kanallarında yükleme tutarı rastgele bir ondalık basamak içerebilir, lütfen ödeme sırasında kontrol edin',
	},
	withdraw:{
		title:'Puan Takası',
		log:'Para Çekme Kaydı',
		method:'Para Çekme Yöntemi',
		avmoney:'Kullanılabilir Puan',
		limit:'Para Çekme Limiti',
		submit:'Puan Çekme Başvurusu',
		xiane:'Tekil Limit',
		numbers:'Para Çekme Sayısı',
		time:'Yatırma Süresi',
		zuidi:'Minimum',
		zuigao:'Maksimum',
		numsmax:'Günlük Maksimum Para Çekme',
		ci:'kez',
		timedetail:'Normal yatırma süresi yaklaşık 5 dakikadır, en hızlı 2 dakika içinde yatırılır',
		bank:'Banka Kartı',
		status1:'Beklemede',
		status2:'Para Çekme Tamamlandı',
		status3:'Para Çekme Başarısız',
		enterCorrectAmount: 'Lütfen geçerli bir tutar girin',
		selectBankCard: 'Lütfen para çekilecek banka kartını seçin',
		enterPayPassword: 'Lütfen ödeme şifrenizi girin',
	},
	moneylog:{
		title:'Puan Detayları',
		type1:'Yükleme',
		type2:'Bonus',
		type3:'Görev',
		type4:'Bonus',
		type5:'Para Çekme Başarılı',
		type6:'Para Çekme Başarısız',
		rechargeNote: '(Yükleme)',
	},
	setting:{
		loginpwdtitle:'Giriş Şifresini Değiştir',
		oldpwd:'Eski şifrenizi girin',
		newpwd:'Yeni şifrenizi girin',
		renewpwd:'Yeni şifrenizi yeniden girin',
		change:'Değiştir',
		plseall:'Girilen şifreler eşleşmiyor!',
		pswwrong:'Şifre girişleri iki kez eşleşmedi',
		paypwdtitle:'Bakiye Şifresi Ayarı',
		paypwd:'Para çekme hesap şifrenizi girin',
		repaypwd:'Şifreyi onaylayın',
		title: 'Ayarlar',
		basicInfo: 'Temel Bilgi Ayarları',
		loginPassword: 'Giriş Şifresi',
		fundPassword: 'Bakiye Şifresi',
		logout: 'Çıkış Yap',
		payPasswordSet: 'Para çekme şifresi ayarlanmış. Değiştirmek için müşteri hizmetleriyle iletişime geçin',
		payPasswordNotSet: 'Ayarlanmamış',
		payPasswordHasSet: 'Ayarlanmış',
		confirm: 'Onayla',
	},
	home:{
		gonggao:'En Üst Düzey Lüks Deneyimin Tadını Çıkarın',
		qgkf:'Ülke Genelinde Hizmet Verilir',
		hotlist:'Popüler Tavsiye Listesi',
		hotgame:'Görev Aktivasyonu',
		gaoji:'Premium',
		smrz:'Gerçek Kimlik Doğrulama',
		videorz:'Kişisel Video Doğrulama',
		star:'Değerlendirme',
		sg:'Boy',
		xw:'Beden',
		diqu:'Hizmet Verilen Bölgeler',
		apply:'Randevu Başvurusu',
		ssxz:'Gerçek Zamanlı Durum',
		joinvip:'üye oldu',
	},
	video:{
		title:'Videolar',
		nums:'İzlenme Sayısı',
		bofangliang:'İzlenme Sayısı',
		hotlist:'Popüler Tavsiye',
		plsrefisrt:'Lütfen videoyu izlemek için yükleme yapın!',
	    trialEnded: 'Önizleme Sona Erdi',
	    rechargeToWatch: 'Yükleme yaptıktan sonra ücretsiz izleyebilirsiniz',
	    goRecharge: 'Hemen Yükle',
	},
	choose:{
		title:'En İyi Gece',
		nav:'Profil',
		apply:'Eşleşme Başvurusu',
		jianjie:'Yönetici Profili',
		move:'Taşınabilir',
		click:'Doğrulamak için tıklayın',
		detail:'Detaylar',
		videodetail:'Canlı Video',
	},
	common:{
		refresh:'Yenileme başarılı',
		noallow:'Özellik etkin değil!',
		disable:'Etkin Değil',
		all:'Tümü',
		nomore:'Daha fazla yok',
		nodata:'Veri yok',
		submit:'Gönder',
		more:'Daha Fazla Yönetici Gör',
		pinglunnav:'Yorumlar',
		pingluntitle:'Yönetici Yorumları',
		pldtitle:'Yorum Detayları',
		minenav:'Hesabım',
		homenav:'Ana Sayfa',
		addbank:'Yatırma Kartı Ekle',
		setbank:'Para Çekme Hesabı Kaydı',
        confirm: 'Onayla',
        cancel: 'İptal',
	},
	game:{
		expect:'Dönem',
		jieguo:'Veri',
		da:'İlkbahar',      // 大 -> 春
        xiao:'Yaz',    // 小 -> 夏
        dan:'Sonbahar',          // 单 -> 秋
        shuang:'Kış',       // 双 -> 冬
        大:'İlkbahar',      // 大 -> 春
        小:'Yaz',      // 小 -> 夏
        单:'Sonbahar',           // 单 -> 秋
        双:'Kış',           // 双 -> 冬
		order:'Görev Şartnamesi',
		clear:'Siparişi Temizle',
		submit:'Onayla ve Gönder',
		kjcc:'Kazanç başarılı, dönem:',
		lxgly:'Bu görev için yöneticiye danışın',
		plsmoney:'Lütfen tutar girin!',
		plsnum:'Lütfen bir sayı seçin!',
		moneynote:'Yetersiz bakiye, yükleme için müşteri hizmetleriyle iletişime geçin!',
		lefttime:'Kalan Süre',
		lunci:'Dönem',
		workRecord: 'Görev Kaydı',
		day: 'Gün',
		period: 'Dönem',
		allWork: 'Tüm Görevler',
		reset: 'Sıfırla',
		confirm: 'Onayla',
		bonusPoints: 'Bonus Puanlar',
		missionMoney: 'Görev Tutarı Detayları',
		missionResult: 'Görev Sonucu',
		points: 'Puan',
		workPoints: 'Görev Puanı',
		giftCompleted: 'Hediye Tamamlandı',
		orderTime: 'Sipariş Zamanı:',
		detail: 'Detay',
		content: 'İçerik',
		amount: 'Tutar',
		result: 'Sonuç',
		time: 'Zaman',
		win: 'Kazanç',
		missionFailed: 'Görev Başarısız',
	},
	kefu:{
		title:'Canlı Müşteri Hizmetleri',
		lianxi:'İletişim',
		content:'7/24 Hizmet',
		defaultName: 'Çevrimiçi Hizmet',
	},
	setname:{
		title:'Gerçek İsim Düzeltme',
		xingming:'İsim',
		tips:'Hesap güvenliği için gerçek isim, bağlı banka kartındaki isimle eşleşmelidir',
		xmpls:'Gerçek isminizi girin',
		save:'Kaydet',
		notreset:'Ayarı tekrarlamayın!',
		plsentername:'Lütfen isim girin!',
	},
	// 追加された言語キー (Eklenen dil anahtarları)
	withdrawCenter: 'Para Çekme Merkezi',
	withdrawRecord: 'Para Çekme Kaydı',
	withdrawAmount: 'Para Çekme Tutarı',
	allMoney: 'Tümü',
	singleLimit: 'Tekil Limit',
	lowest: 'En Düşük',
	highest: 'En Yüksek',
	withdrawTimes: 'Para Çekme Sayısı',
	maxDailyWithdraw: 'Günlük Maks. Para Çekme',
	times: 'kez',
	arrivalTime: 'Yatırma Süresi',
	limitDescription: 'Limit Açıklaması',
	balance: 'Bakiye',
	withdrawNow: 'Hemen Çek',
	enterCorrectAmount: 'Geçerli bir tutar girin',
	personalReport: 'Kişisel Rapor',
	profitAmount: 'Kâr Tutarı',
	profitFormula: 'Kâr Formülü: Kazanç Tutarı - Görev Tutarı',
	taskAmount: 'Görev Tutarı',
	accountOffline: 'Hesap Çevrimdışı',
	loginRegister: 'Giriş Yap / Kayıt Ol',
	loginForMore: 'Daha fazla hizmetin tadını çıkarmak için giriş yapın!',
	// コメント関連 (Yorum İlişkili)
	author: 'Yazar:',
	notification: 'Bildirim',
	// 設定関連 (Ayar İlişkili)
	changePhone: 'Cep Telefonu Numarasını Değiştir',
	save: 'Kaydet',
	existingPhone: 'Mevcut Cep Telefonu Numarası',
	newPhone: 'Yeni Cep Telefonu Numarası',
	// 銀行関連 (Banka İlişkili)
	withdrawAccountRegister: 'Para Çekme Hesabı Kaydı',
	selectBankCard: 'Lütfen banka kartı seçin',
	accountNumber: 'Hesap Numarası',
	enterBankCardNumber: 'Banka kartı numarasını girin',
	// 通知関連 (Bildirim İlişkili)
	systemNotice: 'Sistem Bildirimi',
	// 視聴記録関連 (İzleme Kaydı İlişkili)
	myMovie: 'Filmlerim',
	completeTaskForMore: 'Daha fazla film bileti almak için görevleri tamamlayın',
	movieTicket: 'Film Bileti:',
	watchList: 'İzleme Listesi',
	noDataYet: 'Henüz veri yok',
	// その他 (Diğer)
	setNameFirst: 'Para çekme hesabı bağlamadan önce lütfen isminizi ayarlayın!',
	setPasswordFirst: 'Banka kartı bağlamadan önce lütfen para çekme şifrenizi ayarlayın!',
	// 銀行関連 (Banka İlişkili)
	accountHolder: 'Hesap Sahibi',
	enterRealName: 'Gerçek isminizi girin',
	withdrawPassword: 'Para Çekme Şifresi',
	registerWithdrawPassword: 'Para çekme şifrenizi kaydedin',
	bankCard: 'Banka Kartı',
	// ゲーム関連 (Oyun İlişkili)
	orderContentLabel: 'Sipariş İçeriği:',
	all: 'Tümü',
	bonusPointsLabel: 'Bonus Puanlar',
	waitingResultLabel: 'Sonuç Bekleniyor',
	missionMoneyDetails: 'Görev Tutarı Detayları',
	points: 'Puan',
	// 宝くじ関連 (Piyango İlişkili)
	switch: 'Anahtar',
	currentSelection: 'Mevcut Seçim:',
	quantity: 'Miktar:',
	total: 'Toplam',
	ticketAmount: 'Bilet Sayısı',
	availablePoints: 'Kullanılabilir Puan',
	verify: 'Doğrula',
	// プロフィール関連 (Profil İlişkili)
	possible: 'Mümkün',
	thumb: 'Başparmak',
	privacyPolicy: 'Gizlilik Politikası',
	romanticDescription: 'Romantik hizmetimiz, üyelerin kişisel bilgilerini korumak için yalnızca gerçek kimlik doğrulama hizmetini tamamlayarak veya doğrulanmış üyelerin tavsiyesi yoluyla kayıt olmanıza izin verir.',
	// ホーム関連 (Ana Sayfa İlişkili)
	person1: 'Xia Yu',
	person2: 'Min Xue',
	lishijl: 'Geçmiş Kaydı'
};